/**
 * Sentry initialization for the HyveAI client portal.
 *
 * Requires REACT_APP_SENTRY_DSN to be set in the build environment.
 * No-op when the DSN is missing — safe to call in dev without configuration.
 */
import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    // eslint-disable-next-line no-console
    console.info("Sentry disabled: REACT_APP_SENTRY_DSN not set");
    return;
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_ENV || "production",
    release: process.env.REACT_APP_VERSION || "unknown",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: parseFloat(
      process.env.REACT_APP_SENTRY_TRACES_RATE || "0.1",
    ),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Strip auth headers from breadcrumbs before sending
      if (event.breadcrumbs) {
        event.breadcrumbs.forEach((b) => {
          if (b.data?.headers?.Authorization) {
            b.data.headers.Authorization = "[redacted]";
          }
        });
      }
      return event;
    },
  });
}

export { Sentry };
